import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { TWITTER_COLOR } from "../../../../constants/socialColors.constant";
import { IconProps } from "../Facebook/FacebookIcon";

export const TwitterIcon = (props: IconProps) => {
  const { active, className, size, color } = props;
  return (
    <FontAwesomeIcon
      style={{
        color: color || (active ? TWITTER_COLOR : "gray"),
      }}
      icon={["fab", "twitter"]}
      className={className}
      size={size}
    />
  );
};
